import http from "../http-common";
class QuotaService {

    listQuotaByIdEnquesta(idEnquesta){
        return http.get("/quota/list/"+idEnquesta, {})
    }

    listQuotaByActivacioEnquesta(data) {
        return http.get("/quota/enquesta/"+data.idEnquesta+"/activacio/"+data.idActivacio+"/enquestats/"+data.totalEnquestats);
    }
}
export default new QuotaService();